import { Component, EventEmitter, HostListener, Inject, Input, OnDestroy, Output, ViewChild } from "@angular/core";
import { AfterViewInit } from "@angular/core";
import { isEmpty } from "lodash";
import { Subscription } from "rxjs";
import { FILES_STATE_PROP } from "../../../+authenticated/+product-detail/state-props";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { CommonFieldManagerDirective } from "../common-form/field-manager.directive";
import { CommonListActionsDirective } from "../common-list/actions.directive";

type T_ACTION_LABELS = "Done" | "Save & Close";
type T_ACTION_TYPES = "cancel" | "save";
const ACTION_LABELS: { [fileState: string]: T_ACTION_LABELS } = { noFiles: "Done", withFiles: "Save & Close" };
const ACTION_TYPES: { [fileState: string]: T_ACTION_TYPES } = { noFiles: "cancel", withFiles: "save" };

@Component({
    selector: "file-attachment-manager",
    templateUrl: "./file-attachment-manager.component.html",
    styleUrls: [
        "./file-attachment-manager.component.scss",
        "../../../shared/styles/_components.modal.scss",
    ],
})
export class FileAttachmentManagerComponent implements AfterViewInit, OnDestroy {
    @Input() public stateProp: string;
    @Input() public propSuffix: string;
    @Input() public detailId: string;
    @Input() public downloadPath: string;
    @Input() public showClassify = true;
    @Output() public formEvents: EventEmitter<any> = new EventEmitter();
    @Output() public done: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild(CommonListActionsDirective, { static: false }) public listActions: CommonListActionsDirective;
    @ViewChild("fileFieldManager", { static: false }) public fileFieldManager: CommonFieldManagerDirective;

    public filesUpToDate = true;
    public closeFormActionLabel: T_ACTION_LABELS = ACTION_LABELS.noFiles;
    public closeFormActionType: T_ACTION_TYPES = ACTION_TYPES.noFiles;
    private attachedFiles;
    private fileSubscription$: Subscription;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(FILES_STATE_PROP) private filesStateProp) { }

    public ngAfterViewInit() {
        this.fileSubscription$ = this.ngRedux.select([
            "commonForms",
            this.stateProp,
            "formData",
        ] as any).subscribe((state) => {
            this.attachedFiles = state.files;
        });
    }

    public ngOnDestroy() {
        this.fileSubscription$.unsubscribe();
        this.formEvents.emit("closed");
    }

    public forcedRefresh() {
        this.listActions.getList();
    }

    @HostListener("click", ["$event"])
    public onClick(e) {
        e.stopPropagation();
    }

    public filesChanged(e = []) {
        this.closeFormActionLabel = e.length ? ACTION_LABELS.withFiles : ACTION_LABELS.noFiles;
        this.closeFormActionType = e.length ? ACTION_TYPES.withFiles : ACTION_TYPES.noFiles;
    }

    public formSaveAttempt(e) {
        this.forcedRefresh();
        this.fileFieldManager.resetState();
    }

    handleClear(formManager, e) {
        if (!this.attachedFiles) { return; }

        e.preventDefault();
        formManager.removeFieldFromForm(this.filesStateProp);
    }

    isAttachLocked() {
        return isEmpty(this.attachedFiles);
    }

    onDone() {
        setTimeout(() => {
            this.done.emit();
        }, 500);
    }
}
